import { Component, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'lib-checkbox',
  templateUrl: './checkbox.component.html',
  imports: [MatIconModule],
})
export class CheckboxComponent {
  public readonly label = input.required<string>();

  public readonly checked = input(false);

  public readonly disabled = input(false);

  public readonly changed = output<boolean>();

  onChange(event: Event): void {
    if (this.disabled()) {
      return;
    }

    this.changed.emit((event.target as HTMLInputElement).checked);
  }
}
